import { StationsModel } from '../models/stations';

export class StationsAdapter {
  static fromApi(data: any): StationsModel {
    return {
      id: data.id,
      code: data.code,
      identifier: data.identifier,
      description: data.description,
      latitude: data.latitude,
      longitude: data.longitude,
      altitude: data.altitude,
      startingYearHistory: data.startingYearHistory,
      radiationBalance: data.radiationBalance,
      radiationBalanceValue: data.radiationBalanceValue,
      heatFlow: data.heatFlow,
      heatFlowValue: data.heatFlowValue,
      automaticWeatherStation: data.automaticWeatherStation,
      publishData: data.publishData,
      estimateTemperature: data.estimateTemperature,
      sadEnabled: data.sadEnabled,
      active: data.active,
      inactivityType: data.inactivityType,
      inactivityDescription: data.inactivityDescription,
      cityId: data.cityId,
      weatherStationType: data.weatherStationType,
      equipmentResponsibleId: data.equipmentResponsibleId,
      propertyId: data.propertyId,
    };
  }
}
